import * as React from "react";

import OfferFormContainer from "../../containers/Offers/OfferForm/OfferFormContainer";

export const OfferCreateScene: React.FC = (): JSX.Element => (
  <div>
    <OfferFormContainer state={"creation"} />
  </div>
);
